"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateType = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _2 = require("../..");

var _sbLocale = require("../../sb-locale");

var _sbStructuredFilterUtils = require("../sb-structured-filter-utils");

var _sbStructuredFilterI18n = require("../sb-structured-filter-i18n");

var _constants = require("../../sb-date-time/constants");

var _sbStructuredFilterConstants = require("../sb-structured-filter-constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _DateType = /*#__PURE__*/function (_Component) {
  _inherits(_DateType, _Component);

  var _super = _createSuper(_DateType);

  function _DateType(props) {
    var _values$from, _values$to;

    var _this;

    _classCallCheck(this, _DateType);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (values) {
      var _values$fromText, _values$toText, _values$fromISO, _values$toISO;

      var onChange = _this.props.onChange;
      var _this$state = _this.state,
          fromTextValue = _this$state.fromTextValue,
          toTextValue = _this$state.toTextValue,
          toISO = _this$state.toISO,
          fromISO = _this$state.fromISO;
      onChange(_objectSpread(_objectSpread({}, values), {}, {
        fromText: (_values$fromText = values.fromText) !== null && _values$fromText !== void 0 ? _values$fromText : fromTextValue,
        toText: (_values$toText = values.toText) !== null && _values$toText !== void 0 ? _values$toText : toTextValue,
        fromISO: (_values$fromISO = values.fromISO) !== null && _values$fromISO !== void 0 ? _values$fromISO : fromISO,
        toISO: (_values$toISO = values.toISO) !== null && _values$toISO !== void 0 ? _values$toISO : toISO
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFromDateChange", function (from) {
      var values = _this.props.values;

      _this.setState({
        fromTextValue: from.textValue,
        fromISO: from.valueISO
      });

      _this.onChange((0, _sbStructuredFilterUtils.mergeObjects)(values, {
        from: from.value,
        fromText: from.textValue,
        fromISO: from.valueISO
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToDateChange", function (to) {
      var values = _this.props.values;

      _this.setState({
        toTextValue: to.textValue,
        fromISO: to.valueISO
      });

      _this.onChange((0, _sbStructuredFilterUtils.mergeObjects)(values, {
        to: to.value,
        toText: to.textValue,
        toISO: to.valueISO
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFromFocus", function () {
      _this.setState({
        fromOpen: true,
        toOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToFocus", function () {
      _this.setState({
        toOpen: true,
        fromOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOverlayClick", function () {
      var _this$props$values = _this.props.values,
          from = _this$props$values.from,
          to = _this$props$values.to;

      _this.onChange({
        from: from,
        to: to
      });

      _this.setState({
        fromOpen: false,
        toOpen: false
      });
    });

    var formatOutput = props.sbLocale.format,
        format = props.format,
        locale = props.locale,
        timeZone = props.timeZone,
        _values = props.values;
    var dateTimeFormat = (0, _sbStructuredFilterUtils.getDateTimeFormat)({
      format: format,
      locale: locale,
      timeZone: timeZone
    });
    var textOutputFrom = formatOutput({
      value: (_values$from = _values.from) !== null && _values$from !== void 0 ? _values$from : (0, _sbStructuredFilterConstants.getTodayDate)(),
      format: dateTimeFormat
    });
    var textOutputTo = formatOutput({
      value: (_values$to = _values.to) !== null && _values$to !== void 0 ? _values$to : new Date(),
      format: dateTimeFormat
    });
    var _fromISO = null;
    var _toISO = null;
    _this.state = {
      fromTextValue: textOutputFrom,
      toTextValue: textOutputTo,
      fromOpen: false,
      toOpen: false,
      fromISO: _fromISO,
      toISO: _toISO
    };
    setTimeout(function () {
      _this.onChange(_objectSpread(_objectSpread({}, _values), {}, {
        fromText: textOutputFrom,
        toText: textOutputTo
      }));
    }, 1);
    return _this;
  }

  _createClass(_DateType, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          fromOpen = _this$state2.fromOpen,
          toOpen = _this$state2.toOpen;
      var _this$props = this.props,
          _this$props$values2 = _this$props.values,
          from = _this$props$values2.from,
          to = _this$props$values2.to,
          _ = _this$props.formatMessage,
          format = _this$props.format,
          locale = _this$props.locale,
          timeZone = _this$props.timeZone;
      var now = new Date(); // This protects against javascript dates being passed in.
      // in case of null we fallback to now

      var dateFrom = new Date(from !== null && from !== void 0 ? from : now);
      var dateTo = new Date(to !== null && to !== void 0 ? to : now);
      var dateTimeFormat = (0, _sbStructuredFilterUtils.getDateTimeFormat)({
        format: format,
        locale: locale,
        timeZone: timeZone
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "fl-column history-date-filters"
      }, (fromOpen || toOpen) && /*#__PURE__*/_react.default.createElement("div", {
        className: "date-overlay",
        onClick: this.handleOnOverlayClick
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "fl-row fl-align-items-center filter-date-row"
      }, /*#__PURE__*/_react.default.createElement("label", null, _(_sbStructuredFilterI18n.messages.from)), /*#__PURE__*/_react.default.createElement(_2.SbDateTime, {
        onChange: this.handleOnFromDateChange,
        onFocus: this.handleOnFromFocus,
        value: dateFrom,
        format: dateTimeFormat,
        open: fromOpen,
        locale: locale,
        onIconClick: function onIconClick() {
          return _this2.setState({
            fromOpen: true
          });
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "fl-row fl-align-items-center filter-date-row"
      }, /*#__PURE__*/_react.default.createElement("label", null, _(_sbStructuredFilterI18n.messages.to)), /*#__PURE__*/_react.default.createElement(_2.SbDateTime, {
        onChange: this.handleOnToDateChange,
        onFocus: this.handleOnToFocus,
        value: dateTo,
        format: dateTimeFormat,
        open: toOpen,
        locale: locale,
        onIconClick: function onIconClick() {
          return _this2.setState({
            toOpen: true
          });
        }
      })));
    }
  }]);

  return _DateType;
}(_react.Component);

_defineProperty(_DateType, "propTypes", {
  values: _propTypes.default.shape({
    from: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
    to: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string])
  }),
  timeZone: _propTypes.default.string,
  onChange: _propTypes.default.func,
  formatMessage: _propTypes.default.func.isRequired,
  format: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  locale: _propTypes.default.string,
  sbLocale: _sbLocale.sbLocaleShape.isRequired
});

_defineProperty(_DateType, "defaultProps", {
  onChange: function onChange() {},
  values: {
    from: (0, _sbStructuredFilterConstants.getTodayDate)(),
    to: new Date()
  },
  format: _constants.DEFAULT_FORMAT,
  locale: 'en',
  timeZone: 'UTC'
});

var DateType = (0, _sbLocale.injectSbLocale)(_DateType);
exports.DateType = DateType;
//# sourceMappingURL=date-type.js.map